// =============================================================================
// INPUT COMPONENT
// =============================================================================

import React from 'react';
import type { InputProps } from '@/types';

export function Input({
  type = 'text',
  placeholder,
  value,
  onChange,
  disabled = false,
  required = false,
  error,
  label,
  className = '',
  ...props
}: InputProps) {
  const inputId = React.useId();

  return (
    <div className={`input-wrapper ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        required={required}
        className={`input ${error ? 'input-error' : ''}`}
        {...props}
      />
      {error && (
        <span className="input-error-message">
          {error}
        </span>
      )}
    </div>
  );
}
